<div class="my-24 flex flex-col gap-24 p-4 md:my-28 md:gap-28">
  <!-- Hero -->
  <app-app-store-publishing-hero-section
    id="hero"
  ></app-app-store-publishing-hero-section>
  <!-- Video -->
  <app-video-section
    id="video"
    src="assets/videos/app-store-publishing-demo.mp4"
  ></app-video-section>
  <!-- Social Proof -->
  <app-customer-logo-section id="customers"></app-customer-logo-section>
  <!-- How it works -->
  <app-app-store-publishing-how-it-works-section
    id="how-it-works"
  ></app-app-store-publishing-how-it-works-section>
  <!-- Features -->
  <app-app-store-publishing-features-section
    id="features"
  ></app-app-store-publishing-features-section>
  <!-- Destinations -->
  <app-app-store-publishing-destinations-section
    id="destinations"
  ></app-app-store-publishing-destinations-section>
  <!-- Automation -->
  <app-app-store-publishing-automation-section
    id="automation"
  ></app-app-store-publishing-automation-section>
  <!-- Integrations -->
  <!-- <app-app-store-publishing-integrations-section
    id="integrations"
  ></app-app-store-publishing-integrations-section> -->
  <!-- Statistics -->
  <app-app-store-publishing-statistics-section
    id="statistics"
  ></app-app-store-publishing-statistics-section>
  <!-- Social Proof -->
  <app-testimonials-section id="testimonials"></app-testimonials-section>
  <!-- Blog -->
  <app-blog-section id="blog" [posts]="blogPosts"></app-blog-section>
  <!-- FAQ -->
  <app-app-store-publishing-faq-section
    id="faq"
  ></app-app-store-publishing-faq-section>
  <!-- CTA -->
  <app-app-store-publishing-cta-section
    id="cta"
  ></app-app-store-publishing-cta-section>
</div>
